type ModalType = 'both' | 'qualification' | 'disqualification' | null;

export const hasQualifyingAnswers = (screener: Screener): boolean => {
  return screener.fields?.some((field) => field.answer_tag_logic?.some((tag) => tag.tag_type === 'ideal')) || false;
};

export const hasDisqualifyingAnswers = (screener: Screener): boolean => {
  return (
    screener.fields?.some((field) =>
      field.answer_tag_logic?.some((tag) => tag.tag_type === 'disqualifying' || tag.tag_type === 'ignore_disqualified')
    ) || false
  );
};

export const getScreenerValidation = (
  screener: Screener,
  study: Study | undefined
): { shouldShowModal: boolean; modalType: ModalType } => {
  if (!study) return { shouldShowModal: false, modalType: null };

  const { qualification_screener_review, disqualification_screener_review } = study;

  const qualificationIsAuto = qualification_screener_review === 'auto';
  const disqualificationIsAuto = disqualification_screener_review === 'auto';

  const hasQualifying = hasQualifyingAnswers(screener);
  const hasDisqualifying = hasDisqualifyingAnswers(screener);

  if (qualificationIsAuto && disqualificationIsAuto && !hasQualifying && !hasDisqualifying) {
    return {
      shouldShowModal: true,
      modalType: 'both' as const
    };
  }

  if (disqualificationIsAuto && !hasDisqualifying) {
    return {
      shouldShowModal: true,
      modalType: 'disqualification' as const
    };
  }

  if (qualificationIsAuto && !hasQualifying) {
    return {
      shouldShowModal: true,
      modalType: 'qualification' as const
    };
  }

  return {
    shouldShowModal: false,
    modalType: null
  };
};

export const getModalContent = (modalType: 'both' | 'qualification' | 'disqualification') => {
  switch (modalType) {
    case 'both':
      return {
        title: 'Automatic review',
        message:
          'Automatic review for qualification and disqualification is enabled. If you continue without marking at least 1 qualifying and 1 disqualifying answer, the screener with default to manual review instead.'
      };
    case 'disqualification':
      return {
        title: 'Automatic disqualification',
        message:
          'Automatic disqualification is enabled, but no answers were marked as disqualifying. If you continue without marking at least 1 disqualifying answer, the screener will default to manual review instead.'
      };
    case 'qualification':
      return {
        title: 'Automatic qualification',
        message:
          'Automatic qualification is enabled, but no answers were marked as qualifying. If you continue without marking at least 1 qualifying answer, the screener will default to manual review instead.'
      };
  }
};

export type { ModalType };
